<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar v-if="$store.state.user?$store.state.user.bar:false">
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            path: '/dashboard',
            icon: 'ni ni-tv-2 text-primary',
          }"
        >
        </sidebar-item>

<!--        <sidebar-item v-if="$store.state.user.lxvl===0"
            :link="{
              name: 'Configuaración POS',
              path: '/icons',
              icon: 'ni ni-laptop text-blue'
              }"
            >
              <sidebar-item
                  :link="{
                    name: 'Usuarios POS',
                    path: '/pos-usuarios',
                    icon: 'ni ni-circle-08 text-blue'
                    }"
                  >
              </sidebar-item>
              <sidebar-item
                    :link="{
                      name: 'Cajas',
                      path: '/cajas',
                      icon: 'ni ni-settings text-blue'
                      }"
              ></sidebar-item>
        </sidebar-item>

        <sidebar-item v-if="$store.state.user.lxvl===0"
              :link="{
                name: 'Administración',
                path: '/maps',
                icon: 'ni ni-settings-gear-65 text-orange'
              }">
                <sidebar-item
                    :link="{
                      name: 'Acciones',
                      path: '/pos-acciones',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Módulos',
                      path: '/pos-modulos',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Rol',
                      path: '/pos-roles',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
        </sidebar-item>
      -->

      <!--  <sidebar-item v-if="$store.state.user.lxvl == 0 || $store.state.user.lxvl == 4"
              :link="{
                name: 'Mercadeo',
                path: '/mercadeo',
                icon: 'ni ni-palette text-blue'
                }">
                <sidebar-item
                    :link="{
                      name: 'Customer Display',
                      path: '/customer',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Promociones y Juegos',
                      path: '/qqm',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="$store.state.user.lxvl < 2"
              :link="{
                name: 'Contabilidad',
                path: '/contabilidad',
                icon: 'ni ni-books text-red'
                }">
                <sidebar-item
                    :link="{
                      name: 'Resumen Cajas',
                      path: '/contabilidad',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Listado Turnos arqueados',
                      path: '/resumen-turnos-arqueados',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
        </sidebar-item>-->
        <sidebar-item v-if="$store.state.user.lxvl < 2"
              :link="{
                name: 'Proyectos',
                path: '/proyectos',
                icon: 'ni ni-box-2 text-orange'
                }">
        </sidebar-item>
        <!--<sidebar-item v-if="$store.state.user.lxvl < 2"
              :link="{
                name: 'SNF',
                path: '/layer',
                icon: 'ni ni-box-2 text-orange'
                }">
        </sidebar-item> -->
        <sidebar-item v-if="$store.state.user.lxvl < 2"
              :link="{
                name: 'HerramientaSNF',
                path: '/herramienta',
                icon: 'ni ni-box-2 text-orange'
                }">
        </sidebar-item>
        <sidebar-item v-if="$store.state.user.lxvl===0"
              :link="{
                name: 'Configuración',
                path: '/profile',
                icon: 'ni ni-settings text-blue'
                }">
                <sidebar-item
                    :link="{
                      name: 'Usuarios',
                      path: '/usuarios',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
        </sidebar-item>                     
      <!--  <sidebar-item v-if="$store.state.user.lxvl >= 0 && $store.state.user.lxvl!=11 && $store.state.user.lxvl != 4"
              :link="{
                name: 'Caja Administrativa',
                path: '/caja/administrativa',
                icon: 'ni ni-paper-diploma text-green'
                }">
                <sidebar-item
                    :link="{
                      name: 'Cuadre de Caja',
                      path: '/cuadre-caja',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Resumen de Cajas',
                      path: '/contabilidad',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Listado Turnos arqueados',
                      path: '/resumen-turnos-arqueados',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Faltantes y Sobrantes',
                      path: '/resumen-ventas',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Devoluciones',
                      path: '/devoluciones',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Wallets',
                      path: '/wallets',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Listado Facturas',
                      path: '/listado-facturas',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="$store.state.user.lxvl == 11 || $store.state.user.lxvl == 1 || $store.state.user.lxvl == 0"
              :link="{
                name: 'Seguridad',
                path: '/seguridad',
                icon: 'ni ni-lock-circle-open'
                }">
                <sidebar-item
                    :link="{
                      name: 'Listado Facturas',
                      path: '/listado-facturas',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
                <sidebar-item
                    :link="{
                      name: 'Wallets',
                      path: '/wallets',
                      icon: 'ni ni-settings text-blue'
                      }"
                ></sidebar-item>
        </sidebar-item>-->

       <!-- <sidebar-item
                :link="{
                  name: 'Tables',
                  path: '/tables',
                  icon: 'ni ni-bullet-list-67 text-red'
                }">
        </sidebar-item>

        <sidebar-item
                  :link="{
                    name: 'Login',
                    path: '/login',
                    icon: 'ni ni-key-25 text-info'
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name: 'Register',
                    path: '/register',
                    icon: 'ni ni-circle-08 text-pink'
                  }">
        </sidebar-item>-->
      </template>

      <!--<template slot="links-after">
        <hr class="my-3">
        <h6 class="navbar-heading p-0 text-muted">Documentation</h6>

        <b-nav class="navbar-nav mb-md-3">
          <b-nav-item
               href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard"
               >
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
          </b-nav-item>
          <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard">
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
          </b-nav-item>
        </b-nav>
      </template>-->
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
.bg-white {
    background-color: #f9fafc !important;
    border-right: 1px solid #d2d6de;

}
.navbar-light .navbar-nav .nav-link {
    color: rgba(0, 0, 0, 0.9);
}
</style>
